import resultStyle from "./result.module.css"
import Nav from "./nav"
import { useLayoutEffect, useRef, useState } from "react"
import { useNavigate, useSearchParams } from "react-router"
import Loading from "consumer/setup/loading"
import { check_apply } from "consumer/@@@/check_apply"
import { convert_grade } from "consumer/@@@/convert_grade"
import { get_grade_list } from "consumer/@@@/get_grade_list"
import Button from "consumer/custom/button"
import { Error } from "./error"


export default function Result() {

    const [searchParams, Set_searchParams] = useSearchParams()

    const navigate = useNavigate()

    const isMounted = useRef(0)

    const [consumerId, Set_consumerId] = useState(null)
    const [info, Set_info] = useState(null)
    const [gradeList, Set_gradeList] = useState([])

    const [loading, Set_loading] = useState(true)

    useLayoutEffect(() => {
        const consumer_id = searchParams.get('id')
        if(consumer_id === null) {
            Error()
        }
        else if(isMounted.current === 0) {
            Set_consumerId(consumer_id)
            get_grade_list({
                Set_gradeList: Set_gradeList,
                isMounted: isMounted
            })
        }
    }, [])

    useLayoutEffect(() => {
        if(isMounted.current === 1) {
            check_apply({
                consumer_id: consumerId,
                Set_info: Set_info,
                isMounted: isMounted
            })
        }
    }, [gradeList])

    useLayoutEffect(() => {
        if(isMounted.current === 2) {
            Set_loading(false)
        }
    }, [info])

    return(
        <div
            id="result"
            className={resultStyle['result']}
        >
            <Nav
                step={'result'}
            ></Nav>

            <Loading
                loading={loading}
            ></Loading>

            {info !== null &&
            <>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        width: "100%",
                        marginTop: "50px"
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "30px",
                            fontWeight: "bold",
                            color: "red"
                        }}
                    >
                        {info['order_status'] === true && info['status'] === 1 &&
                            <div>신청이 완료되었습니다!</div>
                        }
                        {info['order_status'] === true && info['status'] === 2 &&
                            <div style={{textAlign: "center"}}>
                                <div>대기 {info['waitCount'] + 1}번으로 신청되었습니다.</div>
                                <div>＊취소자 발생 시 학원에서 연락드리겠습니다.</div>
                            </div>
                        }
                        {info['order_status'] === false &&
                            <>
                                <div style={{marginBottom: "5px"}}>결제가 완료되지 않았습니다!</div>
                                <div
                                    style={{
                                        fontSize: "15px",
                                        color: "gray"
                                    }}
                                >{info['order_expire']}까지 결제를 완료하지 않으면 신청이 취소됩니다.</div>
                            </>
                        }
                    </div>

                    <div
                        style={{
                            height: "max-content",
                            boxSizing: "border-box",
                            fontSize: "20px",
                            marginBlock: "50px"
                        }}
                    >
                        {Array
                        .from([
                            {
                                'name': '신청 학원',
                                'value': info['Schedule']['branchName']
                            },
                            {
                                'name': '학생 이름',
                                'value': info['studentName']
                            },
                            {
                                'name': '보호자 연락처',
                                'value': info['parentPhone']
                            },
                            {
                                'name': '학생 성별',
                                'value': info['studentGender']
                            },
                            {
                                'name': '학생 학년',
                                'value': convert_grade({
                                    grade_list: gradeList,
                                    grade: info['studentGrade']
                                })
                            },
                            {
                                'name': '결제 금액',
                                'value': `${info['order_amount']}원`
                            },
                        ])
                        .map((value, index) => {
                            return(
                                <div
                                    key={index}
                                    style={{
                                        display: "flex",
                                        alignItems: "center"
                                    }}
                                >
                                    <div
                                        style={{
                                            minWidth: "150px",
                                            textAlign: "right",
                                            marginRight: "30px"
                                        }}
                                    >{value['name']}:</div>
                                    <div>{value['value']}</div>
                                </div>
                            )
                        })}
                    </div>
                </div>

                {info['order_status'] === false &&
                    <Button
                        text="결제하러 가기"
                        style={{
                            width: "100%",

                        }}
                        event={{
                            onClick: function() {
                                navigate(`/step4`, {
                                    state: {
                                        consumer_id: info['id']
                                    },
                                    replace: true
                                })
                            }
                        }}
                    ></Button>
                }
            </>
            }


            <Button
                text='처음으로'
                style={{
                    marginTop: "50px",
                    width: "100%"
                }}
                event={{
                    onClick: function() {
                        if(window.confirm('처음으로 돌아가시겠습니까?')) {
                            window.location.replace("/")
                        }
                    }
                }}
            ></Button>
        </div>
    )
}